import React, { useState, useEffect } from 'react';
import 'leaflet/dist/leaflet.css';
import MarkersWrapper, { ShapeType } from '../Shapes/MarkersWrapper';

export interface BreathingMarkerMarkerProps {
    key: string;
    color: string;
    position: any;
    radius: number;
    fteDVMs: number;
    name: string;
    shape: ShapeType;
    showTooltip: boolean;
    onClick?: (event: any) => void;
}

const BreathingMarker = (props: BreathingMarkerMarkerProps) => {
    const intervalUpdateMs = 10;
    const expandMultiplicator = 1.02;
    const maxRadius = props.radius * 3;
    const minOpacity = 0.8;
    const minOpacityForAnimation = 0.5;
    const maxOpacity = 0.01;
    const minRadius = props.radius;
    const [radius, setRadius] = useState(minRadius);
    const [opacity, setOpacity] = useState(minOpacityForAnimation);
    useEffect(() => {
        let growing = true;
        const interval = setInterval(() => {
            setRadius((prevRadius) => {
                if (prevRadius > maxRadius) growing = false;
                if (prevRadius <= props.radius) growing = true;
                return growing ? prevRadius * expandMultiplicator : minRadius;
            });
        }, intervalUpdateMs);

        return () => clearInterval(interval);
    }, [props.radius]);

    useEffect(() => {
        const currentOpacity =
            minOpacity +
            ((radius - minRadius) / (maxRadius - minRadius)) *
                (maxOpacity - minOpacity);

        setOpacity(currentOpacity > maxOpacity ? currentOpacity : maxOpacity);
    }, [radius]);

    return (
        <>
            <MarkersWrapper
                onClick={props.onClick}
                key={props.key}
                showTooltip={props.showTooltip}
                shape={props.shape}
                color={props.color}
                isAnimated={true}
                opacity={opacity}
                position={props.position}
                radius={radius}
                name={props.name}
                fteDVMs={props.fteDVMs}></MarkersWrapper>{' '}
            <MarkersWrapper
                onClick={props.onClick}
                key={props.key}
                showTooltip={props.showTooltip}
                shape={props.shape}
                isAnimated={false}
                color={props.color}
                position={props.position}
                radius={minRadius}
                name={props.name}
                opacity={minOpacity}
                fteDVMs={props.fteDVMs}></MarkersWrapper>
        </>
    );
};

export default BreathingMarker;
